import "./App.css";
import "antd/dist/reset.css";
import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import Private from "./routes/Private";

function App() {
  return (
    <BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
      <Suspense>
        <Private />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
